"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animation = void 0;
const aos_1 = __importDefault(require("aos"));
class Animation {
    static init() {
        aos_1.default.init({
            once: true,
            disable: () => window.innerWidth < 768,
        });
    }
}
exports.Animation = Animation;
